import { FC, useState } from 'react';
import classNames from 'classnames';
import { showToast } from 'components/Toast';
import { copyToClipboard } from 'helpers/clipboard';
import { DashboardScreen, trackEvent } from 'helpers/mixpanelEvents';

const SCREEN: DashboardScreen = 'recipients_dashboard';

interface PublicFundraisingLinkProps {
  className: string;
  url: string;
  hideCardWrapper?: boolean;
  invertCopyButton?: boolean;
}

export const PublicFundraisingLink: FC<PublicFundraisingLinkProps> = ({
  className,
  url,
  hideCardWrapper = false,
  invertCopyButton = false,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    copyToClipboard(url)
      .then(() => {
        trackEvent('Fundraising Link Copied', { screen: SCREEN });
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      })
      .catch(() => {
        showToast('Failed to copy link. Please copy it manually.', 'error');
      });
  };

  const content = (
    <div className="public-fundraising-link__row">
      <div className="public-fundraising-link__details">
        <span className="eyebrow-text color-gray">Your Public Fundraising Link</span>
        <a
          href={url}
          className="body-small-text recipient-dash"
          target="_blank"
          rel="noopener noreferrer"
        >
          {url}
        </a>
      </div>
      <div className="public-fundraising-link__actions">
        <button
          type="button"
          className={classNames('btn', 'btn-secondary', {
            'btn-inkBlue-inverted': invertCopyButton,
            'btn-inkBlue': !invertCopyButton,
          })}
          onClick={handleCopy}
          aria-label="Copy fundraising URL to clipboard"
        >
          <span className={classNames('body-small-text', { 'text-white': !invertCopyButton })}>
            {copied ? 'Copied!' : 'Copy URL'}
          </span>
        </button>
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-inkBlue btn btn-secondary"
          aria-label="View public fundraising page"
          onClick={() => trackEvent('Fundraising Page Link Clicked', { screen: SCREEN })}
        >
          <span className="body-small-text text-white">View</span>
        </a>
      </div>
    </div>
  );

  if (hideCardWrapper) {
    return <div className={className}>{content}</div>;
  }

  return (
    <div className={className}>
      <div className="card">
        <div className="card-body recipients-card-content">{content}</div>
      </div>
    </div>
  );
};
